module.exports = __webpack_public_path__ + "img/3-windows.57de3cc9.svg";